import React from "react";

const Heading = (props) => {
  return <h1 className={`${props.className} text-neon text-2xl tracking-widest`}>{props.text}</h1>;
};

export default Heading;
